// extracted by mini-css-extract-plugin
export var active = "_tj-1";
export var circle = "_tj-0";
export var completed = "_tj-2";
export var connector = "_tj-4";
export var connectorCompleted = "_tj-7";
export var connectorSpacer = "_tj-5";
export var iconStrokeOverride = "_tj-8";
export var labelContainer = "_tj-6";
export var pending = "_tj-3";